var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 29 24",
    xmlns: "http://www.w3.org/2000/svg",
    alt: "social icon for Twitter",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 2.84126C27.933 3.32363 26.7863 3.64848 25.5828 3.79491C26.8117 3.04553 27.7554 1.85808 28.1989 0.442986C27.0498 1.137 25.7762 1.64151 24.4204 1.91345C23.3365 0.735849 21.7887 0 20.0777 0C16.2364 0 13.4137 3.64971 14.2813 7.43847C9.338 7.18622 4.95417 4.77441 2.01912 1.1087C0.460375 3.83183 1.21075 7.39417 3.85942 9.19811C2.8855 9.16612 1.96717 8.89417 1.16604 8.44011C1.10079 11.2469 3.07642 13.8728 5.93775 14.4573C5.10038 14.6887 4.18325 14.7428 3.25042 14.5607C4.00683 16.9676 6.20358 18.7186 8.80875 18.7678C6.3075 20.765 3.15617 21.6571 0 21.2781C2.63296 22.9971 5.76133 24 9.1205 24C20.1671 24 26.4081 14.4992 26.0311 5.97785C27.1935 5.12264 28.2025 4.05578 29 2.84126Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterFilled);
export default __webpack_public_path__ + "static/media/twitter_filled.b56f5c1059fc9397481dd8369d320886.svg";
export { ForwardRef as ReactComponent };